import EquivalencyLookup from './EquivalencyLookup'

// Actions
const ADD_EQUIVALENCY = 'ghg/equivalencies/ADD_EQUIVALENCY';
const CLEAR_EQUIVALENCIES = 'ghg/equivalencies/CLEAR_EQUIVALENCIES';

// Reducer
export const equivalency = (state = {}, action) => {
    switch (action.type) {
        case ADD_EQUIVALENCY:
            return {
                ...state,
                type: action.equivalencyType,
                icon: EquivalencyLookup[action.equivalencyType].icon,
                description: EquivalencyLookup[action.equivalencyType].description,
                info: EquivalencyLookup[action.equivalencyType].info,
                value: EquivalencyLookup[action.equivalencyType].calc(action.value),
            };

        default:
            return state;
    }
};

export default function reducer (state = [], action) {
    switch (action.type) {

        case ADD_EQUIVALENCY:
            const selected = state.filter((equivalency) => equivalency.type === action.equivalencyType);

            if(state.length && selected.length) return state;

            return [
                ...state,
                equivalency(undefined,action)
            ];

        case CLEAR_EQUIVALENCIES:
            return [];

        default:
            return state;
    }
}

// Selectors
export const getEquivalencies = (state) => state.equivalencies;

// Action Creators
export function addEquivalency(equivalencyType,value) {
    return {
        type: ADD_EQUIVALENCY,
        equivalencyType,
        value,
    }
}

export function clearEquivalencies() {
    return {
        type: CLEAR_EQUIVALENCIES
    }
}





/** WEBPACK FOOTER **
 ** ./src/redux/modules/equivalencies/index.js
 **/